import { useMutation, useQueryClient } from '@tanstack/react-query';
import { authService } from '../../services/auth/authService';
import { authQueryKeys } from './queryKeys';
import type { AuthError } from '../../types/auth';

export function useSignOut() {
  const queryClient = useQueryClient();

  return useMutation<void, AuthError, void>({
    mutationFn: async () => {
      const result = await authService.signOut();

      if (!result.success) {
        throw result.error;
      }
    },
    onSuccess: () => {
      // Clear user cache
      queryClient.setQueryData(authQueryKeys.user(), null);
      // Optionally clear entire cache
      queryClient.clear();
    }
  });
}
